
jQuery(function ($) {
    // Remove the 'no-js' <body> class
    $('html').removeClass('no-js');

    //if (!$.support.leadingWhitespace) {
    //    // Superfish for main navigation
    //    $('.menu-primary').superfish();
    //}

    $(function() {
        var pushMenu = new mlPushMenu(
            $('.sb-menu')[0],
            $('.sb-menu--trigger')[0],
            {
                wrapper: $('.site-container')[0]
            }
        );
    });

    //Disable pointer events on scroll
    var disablePointerEventsOnScroll = function() {
        var root = document.documentElement;
        var timer;

        window.addEventListener('scroll', function () {
            // User scrolling so stop the timeout
            clearTimeout(timer);
            // Pointer events has not already been disabled.
            if (!root.style.pointerEvents) {
                root.style.pointerEvents = 'none';
            }

            timer = setTimeout(function () {
                root.style.pointerEvents = '';
            }, 250);
        }, false);
    };
    disablePointerEventsOnScroll();

    $('.ginput_container_select').on('mousedown', function (e) {
        $(this).find('select').click();
        e.stopPropagation();
    });

    $(function () {
        $(".expander > ul > li > br:first-of-type, .expander > ul > li > ul > li > br:first-of-type").remove();
        var i = 0;
        $(".expander > ul > li > strong").each(function () {
            $(this).addClass("alt" + (i % 3));
            i++;
        });
        $(".expander > ul > li > strong").wrap('<a href="#" class="expand"/>');

        $(".expander > ul > li, .expander .expander > ul > li").wrapInner("<span/>");

        $(".expander .expand").each(function () {
            $(this).prependTo($(this).parent().parent());
        });

        // Add class to confirm if default opened or not
        $(".expander").each( function() {

            var $this = $(this);

            if ( $this.hasClass("load-opened") ) {
                $(this).find(".expand").addClass("open").siblings("span").slideDown();
                $(this).find(".expand").siblings("span").slideDown();
            } else {
                $(this).find(".expand").removeClass("open");
                $(this).find(".expand").siblings("span").slideUp();
            }

        });

        $(".expand").click(function (e) {
            e.preventDefault();
            if ($(this).hasClass("open")) {
                $(this).siblings("span").slideUp();
                $(this).removeClass("open");
            } else {
                $(this).addClass("open");
                $(this).siblings("span").slideDown();
            }
        });

    });

});
